"use client";

import { SHOW_BOTTOM_NAV_BAR } from "@/constants/layout";
import { FixedBottomLayout } from "@repo/ui/components";
import { BottomNavBar } from "./BottomNavBar";
import { useMainBottomSlot } from "./MainBottomSlotContext";

export function MainBottomContentStack() {
  const { currentSlotNode } = useMainBottomSlot();

  const content = currentSlotNode ?? (SHOW_BOTTOM_NAV_BAR ? <BottomNavBar /> : null);

  if (!content) return null;

  return <FixedBottomLayout.Content className="px-0">{content}</FixedBottomLayout.Content>;
}
